import type { IFarmStatistics } from 'models/IFarm'
import { COLORS } from 'styles/colors'

/** Фиксированный timestamp (number) для предсказуемости mock-данных */
export const MOCK_TIMESTAMP = 1709827200000

/**
 * Mock данные для превью виджетов в WidgetDock.
 * Используются когда виджет отображается в режиме превью (до добавления на дашборд).
 * Все timestamp — число (Unix ms), как в IFarmStatistics.
 */
export const STATISTICS_MOCK: IFarmStatistics = {
	feedplan: {
		plan_adherence_percent: 95,
	},
	herd: {
		timestamp: MOCK_TIMESTAMP,
		milky: 120,
		dry: 46,
	},
	milkings: {
		timestamp: MOCK_TIMESTAMP,
		today_total: 2450,
		today_total_avg: 20.4,
		to_sell: 2300,
		to_sell_cost: 115000,
		to_sell_avg: 19.2,
		to_sell_avg_cost: 9600,
		rejected_milk: 150,
		rejected_milk_cost: 7500,
		rejected_milk_avg: 1.25,
		rejected_milk_avg_cost: 625,
		rejected_milk_more: false,
		to_sell_more: false,
	},
	tasks: {
		feed_plan: 5,
		limpness: 12,
		trims: 8,
		identification: 3,
	},
	distribution: {
		timestamp: MOCK_TIMESTAMP,
		total: 450,
		cost: 22500,
	},
	cleaning: {
		timestamp: MOCK_TIMESTAMP,
		total: 120,
		cost: 6000,
	},
	psv_avg: {
		timestamp: MOCK_TIMESTAMP,
		total: 85,
		cost: 4250,
	},
	fatness: [
		{ label: 'В норме', color: COLORS.main, value: 95 },
		{ label: 'С отклонением', color: COLORS.health, value: 15 },
		{ label: 'С ожирением', color: COLORS.error, value: 6 },
		{ label: 'С истощением', color: COLORS.black, value: 4 },
	],
	limpness: [
		{ label: '1', color: COLORS.main, value: 110 },
		{ label: '2', color: COLORS.secondary, value: 8 },
		{ label: '3', color: COLORS.pink, value: 2 },
		{ label: '4', color: COLORS.health, value: 2 },
		{ label: '5', color: COLORS.error, value: 2 },
	],
	crit_fatness: {
		timestamp: MOCK_TIMESTAMP,
		count: 3,
		more: false,
	},
	dispose_recommended: {
		timestamp: MOCK_TIMESTAMP,
		count: 5,
		more: false,
	},
	limbs_issues: {
		timestamp: MOCK_TIMESTAMP,
		count: 2,
		more: null,
	},
	psv_milk_cows: {
		timestamp: MOCK_TIMESTAMP,
		count: 115,
		more: false,
	},
	psv_dry_cows: {
		timestamp: MOCK_TIMESTAMP,
		count: 42,
		more: false,
	},
	foodtable: {
		food_available_seconds: 26500,
		low_food_groups: 2,
	},
	food_table_deviations: {
		timestamp: MOCK_TIMESTAMP,
		count: 4,
		more: false,
	},
	average_milking: {
		today_average: 20.4,
		yesterday_average: 19.5,
		total_average: 19.8,
	},
}
